import {
	API_SEARCH_DOCTOR,
	API_GET_DOCTOR_EXISTS,
	API_PATCH_DOCTOR,
	API_POST_DOCTOR,
	API_GET_DOCTOR_ANALYSES,
	API_GET_DOCTOR_PACKS,
	API_POST_COPY_PACK_TO_DOCTOR,
} from "actions/doctor";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_SEARCH_DOCTOR]: {
		default: (size, start) => `/doctors/search/${size}/${start}`,
		v2: (size, start) => `/doctors/search/${size}/${start}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_DOCTOR_EXISTS]: {
		default: (mylabId) => `/doctors/exists/${mylabId}/mylab`,
		v2: (mylabId) => `/doctors/exists/${mylabId}/mylab`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_DOCTOR]: {
		default: () => `/doctors`,
		v2: () => `/doctors`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_DOCTOR]: {
		default: (id) => `/doctors/${id}`,
		v2: (id) => `/doctors/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_DOCTOR_ANALYSES]: {
		default: (doctorId) => `/doctors/analyses/${doctorId}`,
		v2: (doctorId) => `/doctors/analyses/${doctorId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_DOCTOR_PACKS]: {
		default: (doctorCode) => `/doctors/packs/${doctorCode}`,
		v2: (doctorCode) => `/doctors/packs/${doctorCode}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_COPY_PACK_TO_DOCTOR]: {
		default: () => `/doctors/packs`,
		v2: () => `/doctors/copy-pack`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function searchDoctors(searchData, size, start) {
	const version = getVersion(API_SEARCH_DOCTOR);
	const url = typeof version.path === 'function' ? version.path(size, start) : version.path;
	return {
		type: API_SEARCH_DOCTOR,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
				params: searchData,
			},
		},
	};
}

export function getDoctorExists(myLabId) {
	const version = getVersion(API_GET_DOCTOR_EXISTS);
	const url = typeof version.path === 'function' ? version.path(myLabId) : version.path;
	return {
		type: API_GET_DOCTOR_EXISTS,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
			},
		},
	};
}

export function patchDoctor(doctor) {
	const version = getVersion(API_PATCH_DOCTOR);
	const url = typeof version.path === 'function' ? version.path(doctor.id) : version.path;
	return {
		type: API_PATCH_DOCTOR,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: doctor,
			},
		},
	};
}

export function postDoctor(patient) {
	const version = getVersion(API_POST_DOCTOR);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_DOCTOR,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: patient,
			},
		},
	};
}

export function getDoctorAnalyses(doctorId, min_count = 0, with_covid = false) {
	const version = getVersion(API_GET_DOCTOR_ANALYSES);
	const url = typeof version.path === 'function' ? version.path(doctorId) : version.path;
	return {
		type: API_GET_DOCTOR_ANALYSES,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
				params: {
					min_count: min_count,
					with_covid: with_covid,
				},
			},
		},
	};
}

export function getDoctorPacks(doctorCode, doctorMyLabId) {
	const version = getVersion(API_GET_DOCTOR_PACKS);
	const url = typeof version.path === 'function' ? version.path(doctorCode || doctorMyLabId) : version.path;
	return {
		type: API_GET_DOCTOR_PACKS,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
			},
		},
	};
}

export function copyPackToPrescriber(packId, doctor, libelle, name) {
	const version = getVersion(API_POST_COPY_PACK_TO_DOCTOR);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_COPY_PACK_TO_DOCTOR,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: { packId: packId, doctor: doctor, libelle: libelle, name: name },
			},
		},
	};
}
